module.exports = __webpack_public_path__ + "static/media/white_house.e14eaacc.png";